export default __webpack_public_path__ + "static/media/tri-2.5bfb1dde.svg";